export const navTabs = [
  { id: 'topics', label: '专题合集' },
  { id: 'archive', label: '往期回顾' },
  { id: 'timeline', label: '历史存档' },
  { id: 'hot', label: '翻旧账榜' },
  { id: 'comments', label: '热评现场' },
];

export const heroFeature = {
  kicker: '往期回顾 · 历史存档',
  siteName: '黑料社网',
  headline: '把时间掩埋的旧料，一条条重新翻出来',
  lead: '黑料社网不追最新的热闹，只做最全的存档。谁在哪一年说过什么、哪一天被拍到、后来怎样反转，都按时间线一条条摊开。想翻旧账、查历史，从一个关键词开始就够了。',
  featureKicker: '本期主推',
  featureTitle: '顶流组合「五年解绑」时间线：从同框到各自官宣的每一次信号',
  featureSummary:
    '整理 2019 至 2024 的公开行程、采访原话与合作记录，把每一次「刚好错过」和「巧合同款」按顺序复位，文末附当年旧采访的完整摘录。',
  featureMeta: ['收录于 2024 年 11 月存档', '约 12 分钟读完', '含 8 处往期截图'],
  featureTags: ['时间线复盘', '旧采访原话', '前后对比'],
};

export const archiveStats = [
  { value: '1,280', unit: '期', label: '收录期数', tone: 'primary' },
  { value: '9,642', unit: '条', label: '存料条目', tone: 'foreground' },
  { value: '32.7', unit: '万', label: '网友翻账次数', tone: 'accent' },
  { value: '2016', unit: '年起', label: '最早存档年份', tone: 'secondary' },
];

export const topicCollections = [
  {
    id: 'tl',
    name: '时间线复盘',
    icon: 'ri-route-line',
    count: 186,
    desc: '把零散的同框、取关、互删重新排成一条时间轴，前因后果一目了然。',
    tone: 'primary',
  },
  {
    id: 'iv',
    name: '旧采访摘录',
    icon: 'ri-mic-line',
    count: 254,
    desc: '翻出当年说过的话，和后来说过的话对照着读，差别藏不住。',
    tone: 'accent',
  },
  {
    id: 'ph',
    name: '前后对比照',
    icon: 'ri-image-2-line',
    count: 97,
    desc: '同一个人、同一件事，隔几年再看已经完全是两幅面孔。',
    tone: 'secondary',
  },
  {
    id: 'vs',
    name: '声明与反转',
    icon: 'ri-article-line',
    count: 143,
    desc: '从第一次否认到后来承认，两份声明之间的空档最耐看。',
    tone: 'primary',
  },
  {
    id: 'gr',
    name: '旧站台旧节目',
    icon: 'ri-tv-2-line',
    count: 121,
    desc: '已经停播的节目里，藏着如今再没人提起的片段和空镜。',
    tone: 'accent',
  },
  {
    id: 'cm',
    name: '评论区考古',
    icon: 'ri-history-line',
    count: 312,
    desc: '当年的热评，往往比新闻本身更早把结局说了出来。',
    tone: 'secondary',
  },
];

export const archiveReviews = [
  {
    id: 1,
    seq: '1280',
    date: '2024-11-08',
    period: '2024 年 11 月',
    title: '选秀后台花絮旧照：镜头外的那几分钟',
    summary:
      '一段当年没有被播出的后台画面重新整理，配合当期选手后来的发展路线，看这档节目真正改变了谁。',
    tags: ['旧节目', '未播画面'],
    comments: 128,
    hot: 96,
  },
  {
    id: 2,
    seq: '1279',
    date: '2024-11-06',
    period: '2024 年 11 月',
    title: '同一句台词，两个版本：配音更换始末',
    summary:
      '对比两个播出时段的音轨，逐句标出改动位置，还原这段替换是何时、为什么发生的。',
    tags: ['对比听', '存档音频'],
    comments: 76,
    hot: 88,
  },
  {
    id: 3,
    seq: '1278',
    date: '2024-11-03',
    period: '2024 年 11 月',
    title: '合作曲署名争议：旧海报上的名字变了多少次',
    summary:
      '收集七个不同时期的宣传海报与专辑内页，把署名顺序的每一次调整列成表格，不做判断只摆事实。',
    tags: ['旧海报', '时间线'],
    comments: 203,
    hot: 91,
  },
  {
    id: 4,
    seq: '1277',
    date: '2024-10-30',
    period: '2024 年 10 月',
    title: '早年综艺名场面回顾：主持人当年怎么接的话',
    summary:
      '一期停播多年的综艺里，有一段被反复引用的对话，这里补齐前后语境，看完整版原本在说什么。',
    tags: ['旧综艺', '完整语境'],
    comments: 154,
    hot: 82,
  },
  {
    id: 5,
    seq: '1276',
    date: '2024-10-27',
    period: '2024 年 10 月',
    title: '被删掉的三分钟：现场观众回忆整理',
    summary:
      '汇总多位当年在场观众的公开留言，按时间点排列，并与后来放出的片段逐段比对。',
    tags: ['现场回忆', '多方比对'],
    comments: 311,
    hot: 94,
  },
  {
    id: 6,
    seq: '1275',
    date: '2024-10-24',
    period: '2024 年 10 月',
    title: '旧专访里的那句「我们一直有联系」',
    summary: '把当年专访全文的关键段落摘出来，标注提问与回答的间隔，看看话题是怎么被带过去的。',
    tags: ['旧专访', '原话摘录'],
    comments: 92,
    hot: 79,
  },
  {
    id: 7,
    seq: '1274',
    date: '2024-10-20',
    period: '2024 年 10 月',
    title: '十年前的颁奖礼：获奖感言完整文字稿',
    summary: '把颁奖礼当天没有字幕的部分整理成文字，包含台上被打断的那几句和台下的即时反应。',
    tags: ['颁奖礼', '文字整理'],
    comments: 67,
    hot: 74,
  },
  {
    id: 8,
    seq: '1273',
    date: '2024-10-17',
    period: '2024 年 10 月',
    title: '社交平台旧动态归档：改过的那几条',
    summary: '按修改时间排列同一账号的历年动态，标出编辑记录，附上网友当时的截图佐证。',
    tags: ['动态归档', '编辑记录'],
    comments: 188,
    hot: 85,
  },
];

export const hotRanking = [
  { rank: 1, title: '五年前那条秒删动态，配图里还有谁', heat: '18.6 万' },
  { rank: 2, title: '同一件外套，出现了三次不同场合', heat: '15.2 万' },
  { rank: 3, title: '旧采访里被剪掉的那半句回答', heat: '13.9 万' },
  { rank: 4, title: '联合声明发出前 72 小时发生了什么', heat: '11.4 万' },
  { rank: 5, title: '停播节目的最后一期，片尾字幕有彩蛋', heat: '9.8 万' },
  { rank: 6, title: '十年前红毯照片的站位还找得到证据', heat: '8.1 万' },
  { rank: 7, title: '生日祝福的发布时间只差一分半', heat: '7.3 万' },
  { rank: 8, title: '旧专辑内页的致谢名单少了一个人', heat: '6.5 万' },
];

export const hotTags = [
  '时间线复盘',
  '秒删动态',
  '旧采访原话',
  '声明反转',
  '同款物料',
  '未播画面',
  '评论区考古',
  '文字稿整理',
  '旧海报',
  '颁奖礼存档',
];

export const yearArchives = [
  {
    year: '2024',
    count: 214,
    note: '更新最密集的一年',
    entries: [
      { title: '合作曲署名争议时间线', date: '11-03' },
      { title: '被删掉的三分钟现场回忆', date: '10-27' },
      { title: '社交平台旧动态编辑记录', date: '10-17' },
    ],
  },
  {
    year: '2023',
    count: 187,
    note: '声明与反转最集中',
    entries: [
      { title: '两份声明之间的 40 天', date: '08-19' },
      { title: '旧综艺名场面完整语境', date: '06-02' },
      { title: '同款物料的出现顺序', date: '03-25' },
    ],
  },
  {
    year: '2022',
    count: 165,
    note: '旧采访回流最多',
    entries: [
      { title: '专访里那句「一直有联系」', date: '12-11' },
      { title: '停播节目片尾字幕整理', date: '09-07' },
      { title: '红毯站位对照表', date: '05-18' },
    ],
  },
  {
    year: '2021',
    count: 149,
    note: '往期截图修复完成',
    entries: [
      { title: '旧专辑内页致谢名单', date: '11-22' },
      { title: '生日祝福的发布时间差', date: '07-04' },
      { title: '配音更换始末（早期版）', date: '02-16' },
    ],
  },
  {
    year: '2016—2020',
    count: 403,
    note: '早期存档合集，仍在补录',
    entries: [
      { title: '十年前的颁奖礼文字稿', date: '2019-09-30' },
      { title: '第一批旧站台节目清单', date: '2018-04-12' },
      { title: '早期论坛热帖归档', date: '2017-01-08' },
    ],
  },
];

export const commentWall = [
  {
    id: 'c1',
    initial: '张',
    user: '翻旧账的老张',
    time: '3 小时前',
    content:
      '顺着时间线看完，才发现当年那两条动态只隔了一天。黑料社网这次把截图和原话都贴齐了，比我印象里靠谱太多。',
    likes: 1240,
    replies: 86,
    badge: '高赞考古',
  },
  {
    id: 'c2',
    initial: '记',
    user: '备忘录星人',
    time: '昨天',
    content:
      '我是来查历史的，结果从 2018 年一直看到现在。存档做得细，连当时评论区的高赞都留着，翻旧账终于是有据可查了。',
    likes: 968,
    replies: 54,
    badge: '存档长情',
  },
  {
    id: 'c3',
    initial: '档',
    user: '只信原文的档',
    time: '2 天前',
    content:
      '最喜欢「声明与反转」那个合集。同一件事的两份公告并排一放，谁先谁后、改了哪个词，根本不用多解释。',
    likes: 742,
    replies: 41,
    badge: '原件党',
  },
  {
    id: 'c4',
    initial: '路',
    user: '路过补课的路人',
    time: '3 天前',
    content:
      '新粉一枚，靠往期回顾把前面几年补完了。建议每个合集都加个时间轴入口，像我这样从头看的会很省力。',
    likes: 615,
    replies: 73,
    badge: '新人补课',
  },
];

export const categoryTags = [
  { label: '往期回顾', count: 1280 },
  { label: '历史存档', count: 964 },
  { label: '翻旧账', count: 812 },
  { label: '时间线', count: 505 },
  { label: '旧采访', count: 254 },
  { label: '声明反转', count: 143 },
  { label: '未播画面', count: 137 },
  { label: '旧海报', count: 118 },
  { label: '评论区考古', count: 312 },
  { label: '文字稿', count: 206 },
  { label: '前后对比', count: 97 },
  { label: '旧站台', count: 121 },
];

export const footerColumns = [
  {
    title: '关于这份存档',
    links: [
      { label: '黑料社网是什么', href: '#top' },
      { label: '收录与归档标准', href: '#archive' },
      { label: '补录与勘误说明', href: '#timeline' },
      { label: '内容来源与免责声明', href: '#footer' },
    ],
  },
  {
    title: '往期内容分区',
    links: [
      { label: '时间线复盘', href: '#topics' },
      { label: '旧采访摘录', href: '#topics' },
      { label: '声明与反转', href: '#topics' },
      { label: '评论区考古', href: '#comments' },
    ],
  },
  {
    title: '存档导航',
    links: [
      { label: '2024 年存档', href: '#timeline' },
      { label: '2023 年存档', href: '#timeline' },
      { label: '2022 年存档', href: '#timeline' },
      { label: '2016—2020 合集', href: '#timeline' },
    ],
  },
  {
    title: '翻旧账入口',
    links: [
      { label: '本期主推', href: '#top' },
      { label: '翻旧账热搜榜', href: '#hot' },
      { label: '热评现场', href: '#comments' },
      { label: '全部标签', href: '#footer' },
    ],
  },
];